"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  justify-content: space-between;\n  padding-bottom: ", ";\n\n  &,\n  .Header__socialLinks,\n  .Header__apps,\n  .Header__link,\n  .Header__appsLinks {\n    align-items: center;\n    display: flex;\n    height: 24px;\n  }\n\n  .Header_icon {\n    height: 24px;\n    margin-right: ", ";\n    width: 24px;\n  }\n\n  .Header__appsTitle,\n  .Header__link {\n    font-size: .875rem;\n    line-height: 1.43;\n  }\n\n  .Header__appsTitle {\n    color: ", ";\n    font-Family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  }\n\n  .Header__link {\n    color: ", ";\n    text-decoration: none;\n\n    &.Header__lightColor {\n      svg path[fill=\"", "\"] {\n        fill: ", ";\n      }\n    }\n\n    &:hover,\n    &.Header__lightColor:hover {\n      color: ", ";\n\n      svg path[fill=\"", "\"] {\n        fill: ", ";\n      }\n    }\n  }\n\n  .Header__link + .Header__link,\n  .Header__appsTitle + .Header__link {\n    padding-left: ", ";\n  }\n"], ["\n  justify-content: space-between;\n  padding-bottom: ", ";\n\n  &,\n  .Header__socialLinks,\n  .Header__apps,\n  .Header__link,\n  .Header__appsLinks {\n    align-items: center;\n    display: flex;\n    height: 24px;\n  }\n\n  .Header_icon {\n    height: 24px;\n    margin-right: ", ";\n    width: 24px;\n  }\n\n  .Header__appsTitle,\n  .Header__link {\n    font-size: .875rem;\n    line-height: 1.43;\n  }\n\n  .Header__appsTitle {\n    color: ", ";\n    font-Family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  }\n\n  .Header__link {\n    color: ", ";\n    text-decoration: none;\n\n    &.Header__lightColor {\n      svg path[fill=\"", "\"] {\n        fill: ", ";\n      }\n    }\n\n    &:hover,\n    &.Header__lightColor:hover {\n      color: ", ";\n\n      svg path[fill=\"", "\"] {\n        fill: ", ";\n      }\n    }\n  }\n\n  .Header__link + .Header__link,\n  .Header__appsTitle + .Header__link {\n    padding-left: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.space.s300;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s100;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s600;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.boldSmallText.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.boldSmallText.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.boldSmallText.fontWeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.boldSmallText.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s600;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.main.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.main.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s300;
});
var templateObject_1;
